import React from 'react'
import { WithdrawalAmountProps } from '../../lib/types'
import { WithdrawalAmountOpportunityCard } from './withdrawal-amount-opportunity-card'
import { RMContactInfo } from './rm-contact-info'

// COMMENTED OUT: Original imports for withdrawal form functionality
// Will be re-enabled in future when withdrawal flow is restored
/*
import { useEffect, useState } from 'react'
import { WithdrawalApprovalDetails } from '../../lib/types'
import { Button, H4, Input } from '../../lib/components'
import { convertNumberWithCommas, convertToNumber } from '../../lib/utils/helpers'
import { useBreakpoint } from '../../lib/utils/hooks'
import { MD } from '../../lib/utils/constants'
import { withdrawalServices } from '../../services'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
*/

const WithdrawalAmount = ({
  opportunity,
  investmentSummary,
  withdrawalAmount,
}: // COMMENTED OUT: Unused props for withdrawal form functionality
// Will be re-enabled in future when withdrawal flow is restored
// minWithdrawalAmount,
// maxWithdrawalAmount,
// setWithdrawalAmount,
// backToInvestmentHandler,
// handleDisableButton,
// handleSubmitWithdrawalAmount,
WithdrawalAmountProps) => {
  // COMMENTED OUT: Original withdrawal form functionality
  // Will be re-enabled in future when withdrawal flow is restored
  /*
  const { breakpoint } = useBreakpoint()
  const { authToken } = useSelector((state: RootState) => state.investor)
  const [withdrawalDetails, setWithdrawalDetails] = useState<WithdrawalApprovalDetails | null>(null)
  const [isLoadingWithdrawalDetails, setIsLoadingWithdrawalDetails] = useState(false)

  // Fetch withdrawal details when withdrawal amount changes
  useEffect(() => {
    const fetchWithdrawalDetails = async () => {
      if (
        withdrawalAmount &&
        Number(withdrawalAmount) > 0 &&
        opportunity?.id &&
        Number(withdrawalAmount) >= Number(minWithdrawalAmount) &&
        Number(withdrawalAmount) <= Number(maxWithdrawalAmount)
      ) {
        setIsLoadingWithdrawalDetails(true)
        try {
          // Convert withdrawal amount to cents (API expects amount in cents)
          const flooredAmount = Math.floor(Number(withdrawalAmount) * 10) / 10
          const amountInCents = Math.round(flooredAmount * 100)

          const response = await withdrawalServices.getWithdrawalPredictApprovalDetails(
            opportunity.id.toString(),
            amountInCents.toString(),
            {
              Authorization: authToken ? authToken : '',
            },
          )

          if (response?.status === 200 && response?.data) {
            setWithdrawalDetails(response.data)
          } else {
            setWithdrawalDetails(null)
          }
        } catch (error) {
          console.error('Error fetching withdrawal details:', error)
          setWithdrawalDetails(null)
        } finally {
          setIsLoadingWithdrawalDetails(false)
        }
      } else {
        setWithdrawalDetails(null)
        setIsLoadingWithdrawalDetails(false)
      }
    }

    // Debounce the API call to avoid too many requests
    const timeoutId = setTimeout(fetchWithdrawalDetails, 500)
    return () => clearTimeout(timeoutId)
  }, [withdrawalAmount, opportunity?.id, authToken, minWithdrawalAmount, maxWithdrawalAmount])

  const handleInvestErrorMessage = (val: string): { withdrawalAmount?: string } => {
    if (Number(val) > Number(maxWithdrawalAmount)) {
      return {
        withdrawalAmount: `Amount must be less than or equal to $${convertNumberWithCommas(
          maxWithdrawalAmount,
        )}`,
      }
    }
    if (Number(val) < Number(minWithdrawalAmount)) {
      return {
        withdrawalAmount: `Amount must be greater than or equal to $${convertNumberWithCommas(
          minWithdrawalAmount,
        )}`,
      }
    }
    return {}
  }

  const infoText = () => {
    let text = ''

    if (Number(minWithdrawalAmount) === Number(maxWithdrawalAmount)) {
      text = `Minimum and maximum withdrawal amount is $${convertNumberWithCommas(
        parseInt(minWithdrawalAmount ?? '0'),
      )}.`
    } else {
      text = `Minimum withdrawal amount is $${convertNumberWithCommas(
        parseInt(minWithdrawalAmount ?? '0'),
      )}. Maximum withdrawal amount is $${convertNumberWithCommas(Number(maxWithdrawalAmount))}. `
    }

    return text
  }
  */

  return (
    <>
      {opportunity && (
        <WithdrawalAmountOpportunityCard
          opportunity={opportunity}
          investmentSummary={investmentSummary}
          withdrawalDetails={null}
          isLoadingWithdrawalDetails={false}
          withdrawalAmount={withdrawalAmount}
        />
      )}

      {/* Display RM contact info instead of withdrawal form */}
      <RMContactInfo />

      {/* COMMENTED OUT: Original withdrawal form - will be restored in future
      <div className='withdraw-amount-container'>
        <div className='withdraw-amount-column-container'>
          <div className='withdraw-amount-card'>
            <H4 text='Enter withdrawal amount:' />
            <div>
              <span className='dollar-input-icon'> $ </span>
              <Input
                type='text'
                name='withdrawalAmount'
                placeholder='Amount'
                data-testid='withdrawal amount-input'
                value={convertNumberWithCommas(
                  (Math.floor(Number(withdrawalAmount) * 10) / 10).toString(),
                )}
                handleChange={(e) => {
                  const numericValue = convertToNumber(e.target.value)
                  const flooredValue = Math.floor(numericValue * 10) / 10
                  setWithdrawalAmount(String(flooredValue))
                }}
                maxValue={Number(maxWithdrawalAmount)}
                errors={handleInvestErrorMessage(withdrawalAmount)}
                touched={{ withdrawalAmount: true }}
                infoText={infoText()}
              />
            </div>
          </div>
          <div className='stepper-btn-container'>
            <Button
              classes={breakpoint && breakpoint > MD ? ['auto-btn-width'] : ['']}
              text={'Cancel'}
              variant='basic-btn'
              handleClick={() => {
                backToInvestmentHandler()
              }}
            />
            <Button
              classes={breakpoint && breakpoint > MD ? ['auto-btn-width'] : ['']}
              text={'Continue'}
              variant='primary-btn'
              isDisabled={handleDisableButton()}
              handleClick={() => {
                handleSubmitWithdrawalAmount()
              }}
            />
          </div>
        </div>
      </div>
      */}
    </>
  )
}

export { WithdrawalAmount }
